import { Routes, RouterModule }  from '@angular/router';

import { viewRequestsComponent } from './viewrequests.component';
import { viewRequestAddComponent } from './create/create.component';
import { viewRequestReturnComponent } from './return/return.component';
import { viewRequestConfirmComponent } from './confirm/confirm.component';


export const RequestsRoutes: Routes = [
    {
        path: '',
        component: viewRequestsComponent,
        children: [
            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
            { path: 'create/:id', component: viewRequestAddComponent },
            { path: 'return/:id', component: viewRequestReturnComponent },
            { path: 'confirm/:id', component: viewRequestConfirmComponent }
        ]
    }
];

export const RequestsRoutingModule = RouterModule.forChild(RequestsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/viewrequests-routing.module.ts